import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ComponentCanDeactivate } from './component-can-deactivate';
import { SecurityService } from '../security.service';

export const canDeactivateGuard: CanDeactivateFn<ComponentCanDeactivate> = (
    component: ComponentCanDeactivate,
    _route,
    _state,
    nextState,
    translateService: TranslateService = inject(TranslateService),
    securityService: SecurityService = inject(SecurityService)
) => {
    if (nextState.url === '/security' && !securityService.hasPortalAccess()) {
        return true;
    }

    const message = translateService.instant("alerts.unsavedChanges");
    if (!component.canDeactivate()) {
        // eslint-disable-next-line no-alert
        return confirm(message);
    }
    return true;
}
